// extracted by mini-css-extract-plugin
export var addToCartButton = "_o2-b";
export var arrowButtonContainer = "_o2-9";
export var arrowButtonIcon = "_o2-a";
export var carouselArrowButton = "_o2-6";
export var carouselElementContainer = "_o2-1";
export var left = "_o2-7";
export var productDisplayCarouselContainer = "_o2-0";
export var productTileContainer = "_o2-2";
export var productTileImage = "_o2-4";
export var productTileImageContainer = "_o2-3";
export var productTileTitle = "_o2-5";
export var right = "_o2-8";
export var sliderOverflow = "_o2-c";